(function() {
  const YARDAGE_TYPES = ['Yardage', 'Yardage1Min', 'Toweling', 'Batting', 'Interfacing', 'Webbing', 'Elastic'];
  const STEP = 2;
  const DIVIDER = 1 / 8;

  function formatYards(quantity) {
    const yards = quantity * DIVIDER;
    return parseFloat(yards.toFixed(3)).toString();
  }

  // PRODUCT PAGE
  function updateProductDisplay(container, quantity) {
    const input = container.querySelector('[data-qc-input]');
    const hiddenQty = container.querySelector('[data-qc-hidden-quantity]');
    const cutLength = container.querySelector('[data-qc-cut-length]');
    const minusBtn = container.querySelector('[data-qc-minus]');
    const plusBtn = container.querySelector('[data-qc-plus]');
    const min = parseInt(container.dataset.qcMin);
    const max = parseInt(container.dataset.qcMax);

    const yards = quantity * DIVIDER;
    const yardsFormatted = parseFloat(yards.toFixed(3)).toString();
    const yardLabel = parseFloat(yards.toFixed(3)) === 1 ? 'Continuous Yard' : 'Continuous Yards';

    if (input) input.value = yardsFormatted;
    if (hiddenQty) hiddenQty.value = quantity;
    if (cutLength) cutLength.value = yardsFormatted + ' ' + yardLabel;
    if (minusBtn) minusBtn.disabled = quantity <= min;
    if (plusBtn) plusBtn.disabled = quantity + STEP > max;

    container.dataset.qcCurrentQuantity = quantity;
  }

  function initProductContainer(container) {
    if (container.dataset.qcInitialized) return;
    container.dataset.qcInitialized = 'true';

    const productType = container.dataset.qcProductType;
    if (!YARDAGE_TYPES.includes(productType)) return;

    const minusBtn = container.querySelector('[data-qc-minus]');
    const plusBtn = container.querySelector('[data-qc-plus]');
    const min = parseInt(container.dataset.qcMin);

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        let qty = parseInt(container.dataset.qcCurrentQuantity);
        if (qty - STEP >= min) {
          updateProductDisplay(container, qty - STEP);
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        let qty = parseInt(container.dataset.qcCurrentQuantity);
        const max = parseInt(container.dataset.qcMax);
        if (qty + STEP <= max) {
          updateProductDisplay(container, qty + STEP);
        }
      });
    }

    const initialQty = parseInt(container.dataset.qcCurrentQuantity);
    if (initialQty > 0) {
      updateProductDisplay(container, initialQty);
    }
  }

  // CART
  function updateCartDisplay(container, quantity) {
    const input = container.querySelector('[data-qc-input-cart]');
    const hiddenQty = container.querySelector('[data-qc-hidden-quantity-cart]');
    const minusBtn = container.querySelector('[data-qc-minus-cart]');
    const plusBtn = container.querySelector('[data-qc-plus-cart]');
    const min = parseInt(container.dataset.qcMin);
    const max = parseInt(container.dataset.qcMax);

    if (input) input.value = formatYards(quantity);
    if (hiddenQty) hiddenQty.value = quantity;
    if (minusBtn) minusBtn.disabled = quantity <= min;
    if (plusBtn) plusBtn.disabled = quantity + STEP > max;

    container.dataset.qcCurrentQuantity = quantity;
  }

  function initCartContainer(container) {
    if (container.dataset.qcInitialized) return;
    container.dataset.qcInitialized = 'true';

    const productType = container.dataset.qcProductType;
    if (!YARDAGE_TYPES.includes(productType)) return;

    const minusBtn = container.querySelector('[data-qc-minus-cart]');
    const plusBtn = container.querySelector('[data-qc-plus-cart]');
    const min = parseInt(container.dataset.qcMin);

    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        let qty = parseInt(container.dataset.qcCurrentQuantity);
        if (qty - STEP >= min) {
          updateCartDisplay(container, qty - STEP);
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        let qty = parseInt(container.dataset.qcCurrentQuantity);
        const max = parseInt(container.dataset.qcMax);
        if (qty + STEP <= max) {
          updateCartDisplay(container, qty + STEP);
        }
      });
    }

    const initialQty = parseInt(container.dataset.qcCurrentQuantity);
    if (initialQty > 0) {
      updateCartDisplay(container, initialQty);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-qc-container-product]').forEach(initProductContainer);
    document.querySelectorAll('[data-qc-container-cart]').forEach(initCartContainer);
  }

  // Watch for dynamically loaded content (quick add modals etc.)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.matches('[data-qc-container-product]')) {
            initProductContainer(node);
          } else {
            node.querySelectorAll('[data-qc-container-product]').forEach(initProductContainer);
          }
          if (node.matches('[data-qc-container-cart]')) {
            initCartContainer(node);
          } else {
            node.querySelectorAll('[data-qc-container-cart]').forEach(initCartContainer);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();